import React from 'react';
import { Callout, Step, DocHeading } from './components';

function PageActivateKey() {
  return (
    <div>
      <p className="text-sm text-brand-400 font-medium mb-2">Using the Bot</p>
      <h1 className="font-display text-3xl font-bold text-white tracking-tight mb-3">Activating Your Key</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Your license key links your subscription to your hardware. You only need to activate it once.
      </p>

      <DocHeading>Activation via Dashboard</DocHeading>
      <Step n={1} title="Log in to your account">
        Navigate to the Dashboard (<code className="code-inline">/panel</code>)
        and open the <strong>Activate Key</strong> tab.
      </Step>
      <Step n={2} title="Enter your key">
        Type or paste your key in the input field. Keys are in the format{' '}
        <code className="code-inline">XXXX-XXXX-XXXX-XXXX</code>.
      </Step>
      <Step n={3} title="HWID is assigned automatically">
        Your Hardware ID (HWID) is read from your PC by the desktop loader and sent to the server
        on first launch. You do not need to enter it manually on the website — it will be visible
        in your Dashboard once the loader has connected.
      </Step>
      <Step n={4} title="Click Activate Key">
        The key will be validated and linked to your account. You will see a confirmation message
        and the subscription details will update.
      </Step>

      <Callout type="info">
        Each key can only be activated on <strong>one hardware ID</strong>. If you need to reset
        your HWID (e.g. after a hardware upgrade), see the <strong>HWID Issues</strong> page.
      </Callout>

      <DocHeading>Activation via the Loader</DocHeading>
      <p className="text-sm text-gray-400 mb-3">
        The loader does <strong className="text-white">not</strong> have a key entry screen.
        It shows a Login screen where you enter your website <strong>username and password</strong>.
        Key activation must be done through the web Dashboard before launching the loader for the
        first time.
      </p>

      <DocHeading>Key States</DocHeading>
      <div className="card overflow-hidden">
        {[
          { state: 'Unused',   cls: 'text-gray-400',  desc: 'Ready to be activated.' },
          { state: 'Active',   cls: 'text-green-400', desc: 'Linked to your account and HWID, currently valid.' },
          { state: 'Expired',  cls: 'text-gray-500',  desc: 'The subscription period has ended.' },
          { state: 'Frozen',   cls: 'text-blue-400',  desc: 'Temporarily paused by an admin (time is preserved).' },
        ].map(r => (
          <div key={r.state} className="flex items-center gap-3 px-5 py-3 border-b border-white/[0.05] last:border-0 text-sm">
            <span className={`font-semibold w-16 flex-shrink-0 ${r.cls}`}>{r.state}</span>
            <span className="text-gray-400">{r.desc}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PageActivateKey;
